import { render } from "./AckPopup.vue?vue&type=template&id=75e6018a&ts=true"
import script from "./AckPopup.vue?vue&type=script&lang=ts"
export * from "./AckPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__